import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Dimmer, Icon, Loader } from "semantic-ui-react";
import { getPaymentButtonInfo, getPaymentButtonStatus } from "../../service/api";
import CounterTimeComponent from "./CounterTimeComponent";
import NextStepComponent from "../NextStepComponent";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useAuth } from "../shared/AuthContext/AuthContext";
import { Button, Card, Col, Container, Row } from "reactstrap";
import "./RedirectPaymentButtonQR.scss";
import getSymbolFromCurrency from "currency-symbol-map";
import { formatNumber } from "../../utils/utils";
import { AGGREGATORS_ENUM } from "../../utils/Constants";
import CounterTimeCircleCustom from "../shared/CounterTimeCircleCustom/CounterTimeCircleCustom";

const RedirectPaymentButtonQR = () => {
  const [imageContent, setImageContent] = useState("");
  const [textContent, setTextContent] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [currency, setCurrency] = useState("");
  const [errorMessageShow, setErrorMessageShow] = useState(false);
  const [expirationTime, setExpirationTime] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [countSend, setCountSend] = useState(0);
  const [createdAt, setCreatedAt] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [transaledTexts, setTransaledTexts] = useState();
  const [countDownKey, setCountDownKey] = useState(0);

  const params = useParams();
  const { tenant, publicKey } = params;
  const { getAuthToken, qrPageTranslatedTexts, setTranslatedTextsByLanguage } = useAuth();

  const desactiveIsLogin = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const getStatusInfoPayment = async () => {
    const accessToken = await getAuthToken();
    getPaymentButtonStatus(accessToken, tenant, publicKey).then(async (response) => {
      if (response.status == 200) {
        setCountDownKey((lastValues) => lastValues + 1);

        const responseData = await response.data;
        if (responseData.urlRedirect && responseData.urlRedirect.trim()) {
          window.location.replace(responseData.urlRedirect);
        } else {
          return;
        }
      }
    });
  };

  const getData = async () => {
    const accessToken = await getAuthToken();

    getPaymentButtonInfo(accessToken, tenant, publicKey).then(async (response) => {
      if (response.ok) {
        const responseText = await response.text();
        const object = JSON.parse(responseText);

        setImageContent(object.imageContent);
        setTextContent(object.textContent);
        setTotalAmount(object.totalAmount);
        setExpirationTime(object.paymentExpiration);
        setCurrency(object.currency);
        setCreatedAt(object.created_at);

        handleShowOptionsByAggregator(object.aggregatorId);
        handleSetLanguageTexts(object.aggregatorId);
        desactiveIsLogin();
      } else {
        setErrorMessageShow(true);
        desactiveIsLogin();
      }
    });
  };

  const handleShowOptionsByAggregator = (aggregatorId) => {
    switch (aggregatorId) {
      case AGGREGATORS_ENUM.newPay:
      case AGGREGATORS_ENUM.newPayProd:
        setTextContent(null);
        return;
      default:
        return;
    }
  };

  const handleSetLanguageTexts = () => {
    switch (tenant.toUpperCase()) {
      case "BR":
        setTranslatedTextsByLanguage("pt");
        return;
      default:
        return;
    }
  };

  useEffect(() => {
    if (countSend === 0) {
      setIsLoading(true);
      getData();
    }
  }, [countSend]);

  useEffect(() => {
    setTransaledTexts(qrPageTranslatedTexts);
  }, [qrPageTranslatedTexts]);

  return (
    <div>
      {errorMessageShow ? (
        <NextStepComponent message={"ERROR"} typeMessage={"ERROR"}></NextStepComponent>
      ) : (
        <>
          {isLoading && (
            <Dimmer active>
              <Loader size="massive">{transaledTexts?.loading}</Loader>
            </Dimmer>
          )}
          <Container fluid>
            {totalAmount && (
              <Row className="justify-content-center sticky-total">
                <Col xs="12" md="6">
                  <Card body className="p-0">
                    <Row className="align-items-center p-3">
                      <Col md={6} xs={6} className="text-left">
                        <h3 className="font-weight-bold">
                          {transaledTexts?.totalAmount} ({currency})
                        </h3>
                      </Col>
                      <Col md={6} xs={6} className="text-right">
                        <h5 className="font-weight-bold">
                          {getSymbolFromCurrency(currency)} {formatNumber(totalAmount, 2)}
                        </h5>
                      </Col>
                      <Col md={12} xs={12} className="mt-2">
                        <CounterTimeCircleCustom
                          durationSeconds={10}
                          remainingText={transaledTexts.verifyingRemainingTimeText}
                          executingText={transaledTexts.verifyingStatusText}
                          resetKey={countDownKey}
                          onExecuteAction={getStatusInfoPayment}
                        />
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            )}
            <Row className="justify-content-center">
              <Col xs="12" md="6">
                <Card body className="p-0">
                  <Row className="justify-content-center border-bottom position-relative">
                    {imageContent && (
                      <Col
                        xs="12"
                        md="6"
                        className="d-flex flex-column justify-content-center align-items-center p-5 order-3 order-md-1"
                      >
                        <br />
                        <h5 className="mt-4 text-center">{transaledTexts?.scanQr}</h5>
                        <img
                          alt="qrQode"
                          src={`data:image/png;base64, ${imageContent}`}
                          style={{ width: 250 }}
                        />
                      </Col>
                    )}
                    {imageContent && textContent && (
                      <>
                        <div
                          className="d-none d-md-block position-absolute"
                          style={{
                            top: "45%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "white",
                            padding: "10px 10px",
                            zIndex: 1,
                            fontWeight: "bold",
                          }}
                        >
                          {transaledTexts?.or}
                        </div>
                        <div className="d-block d-md-none w-100 d-flex align-items-center my-3 px-3 order-2">
                          <div className="flex-grow-1 border-top" />
                          <span className="px-3 font-weight-bold">{transaledTexts?.or}</span>
                          <div className="flex-grow-1 border-top" />
                        </div>
                      </>
                    )}

                    {textContent && (
                      <Col
                        xs="12"
                        md="6"
                        className="d-flex flex-column justify-content-center align-items-center p-5 border-left order-1 order-md-2"
                      >
                        <br />
                        <h5 className="mt-4 text-center">{transaledTexts?.copyCode}</h5>
                        <CopyToClipboard text={textContent} onCopy={() => setIsCopied(true)}>
                          <Button color="primary">{isCopied ? "Copied!" : "Copy"}</Button>
                        </CopyToClipboard>
                      </Col>
                    )}
                  </Row>
                  {!isLoading && (
                    <Row className="justify-content-center p-4">
                      <Col xs="12" md="6" className="text-center">
                        <h3 className="mb-2">{transaledTexts?.availableTime}</h3>
                        <CounterTimeComponent
                          countSend={countSend}
                          setCountSend={setCountSend}
                          expirationPament={expirationTime}
                          createdDate={createdAt}
                        />
                      </Col>
                    </Row>
                  )}
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  );
};

export default RedirectPaymentButtonQR;
